import { render } from "./OrderProductOptions.vue?vue&type=template&id=4fdc2b9b"
import script from "./OrderProductOptions.vue?vue&type=script&lang=js"
export * from "./OrderProductOptions.vue?vue&type=script&lang=js"
script.render = render

export default script